import { Loader } from "semantic-ui-react";
import { Div } from "../../../StyledComponents";
import SideNav from "../../Sidenav";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import WaitlistTable from "./WaitlistTable";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../../popups/GetStartedPopup";

const AppointmentWaitlist = () => {
  const [navData1, setNavData1] = useState("iconopen");
  const [showAddModal, setShowAddModal] = useState(false);
  const Spinner = useSelector((state) => state.Schedule.DashboardLoading);
  var NavData1 = useSelector((state) => state.Schedule?.NavData);
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const popupStep = searchParams.get("step");
  const isAccountSetupWaitlist =
    searchParams.get("accountSetupWaitlist") === "true";
  const [addWaitlistBtnNode, setAddWaitlistBtnNode] = useState(null);
  const addWaitlistBtnRef = (node) => {
    if (node !== null) {
      setAddWaitlistBtnNode(node);
    }
  };

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  useEffect(() => {
    if (isAccountSetupWaitlist && popupStep === "waitlist4") {
      setShowAddModal(true);
    }
  }, [isAccountSetupWaitlist, popupStep]);
  const showStep3Popup = isAccountSetupWaitlist && popupStep === "waitlist3";

  return (
    <>
      <>
        <SideNav />
      </>
      <div
        id="demographics"
        className={
          (navData1 === "iconopen" && "schedule-right-nav p-r-13") ||
          (navData1 === "iconclose" && "schedule-right-nav1 p-r-13")
        }
      >
        <div className="appt-block-main schedule-comp1 vozo_margin m-b-0">
          {Spinner ? (
            <>
              <Loader />
            </>
          ) : (
            <div className="appt-block-main bord-radius vozo_margin schedule-comp1 pat_Stmt_tab_bot_alt vozo_bottom pading-nil m-b-0">
              <div className="tab_title_main justify-between">
                <div className="tab_title_name">Appointment Waitlist </div>
                <Button
                  ref={addWaitlistBtnRef}
                  className={
                    showStep3Popup ? "appointment-waitlist-target" : ""
                  }
                  onClick={() => setShowAddModal(true)}
                >
                  Add Waitlist
                </Button>

                {/* {showStep3Popup &&
                  (() => {
                    const targetRect = addWaitlistBtnNode
                      ? addWaitlistBtnNode.getBoundingClientRect()
                      : null;

                    const popupWidth = 350;
                    const popupMinHeight = 180;
                    const rightGap = 15;

                    return targetRect ? (
                      <div
                        className="waitlist-icon-popup"
                        style={{
                          position: "fixed",
                          left: `${targetRect.left - popupWidth - rightGap}px`,
                          top: `${targetRect.top - popupMinHeight / 2 + targetRect.height / 2 + 50}px`,
                          zIndex: 1060,
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                          padding: "20px 18px 16px 18px",
                          width: `${popupWidth}px`,
                          minHeight: `${popupMinHeight}px`,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            right: "-10px",
                            top: "20px",
                            width: 0,
                            height: 0,
                            borderTop: "10px solid transparent",
                            borderBottom: "10px solid transparent",
                            borderLeft: "10px solid #ffffff",
                            filter: "drop-shadow(2px 0px 1px rgba(0,0,0,0.1))",
                          }}
                        />

                        <GetStartedPopup
                          title="Adding Appointment Waitlist"
                          bullets={[
                            <>
                              To add Appointment Waitlist, click on the
                              <br />
                              "Add Waitlist" button.
                            </>,
                            <>
                              "By doing so 'Add Waitlist' popup will
                              <br />
                              appear.",
                            </>,
                          ]}
                          currentStep={3}
                          totalSteps={8}
                          onBack={() => {
                            history.push(
                              "/schedule/calender?step=waitlist2&accountSetupWaitlist=true",
                            );
                          }}
                          onNext={() => {
                            setShowAddModal(true);
                            history.push({
                              search:
                                "?step=waitlist4&accountSetupWaitlist=true",
                            });
                          }}
                          onClose={() => {
                            history.push({ search: "" });
                          }}
                          width="310px"
                        />
                      </div>
                    ) : null;
                  })()} */}
              </div>
              <Popup
                open={showStep3Popup}
                context={addWaitlistBtnNode}
                position="left center"
                pinned
                offset={[60, 10]}
                zidIndex={1001}
                style={{
                  zIndex: 800,
                }}
                trigger={<span />}
                content={
                  <GetStartedPopup
                    title="Adding Appointment Waitlist"
                    bullets={[
                      <>
                        To add Appointment Waitlist, click on the
                        <br />
                        "Add Waitlist" button.
                      </>,
                      <>
                        By doing so the "Add Waitlist" popup will
                        <br />
                        appear.
                      </>,
                    ]}
                    currentStep={3}
                    totalSteps={8}
                    width="310px"
                    onBack={() => {
                      history.push(
                        "/schedule/calender?step=waitlist2&accountSetupWaitlist=true",
                      );
                    }}
                    onNext={() => {
                      setShowAddModal(true);
                      history.push({
                        search: "?step=waitlist4&accountSetupWaitlist=true",
                      });
                    }}
                    onClose={() => history.push({ search: "" })}
                  />
                }
              />

              <WaitlistTable
                showAddModal={showAddModal}
                setAddModalShow={setShowAddModal}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AppointmentWaitlist;
